"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratorInfoKind = void 0;
var DecoratorInfoKind;
(function (DecoratorInfoKind) {
    DecoratorInfoKind[DecoratorInfoKind["method"] = 0] = "method";
    DecoratorInfoKind[DecoratorInfoKind["parameter"] = 1] = "parameter";
    DecoratorInfoKind[DecoratorInfoKind["property"] = 2] = "property";
})(DecoratorInfoKind || (exports.DecoratorInfoKind = DecoratorInfoKind = {}));
//# sourceMappingURL=DecoratorInfoKind.js.map